export default __webpack_public_path__ + "static/media/so.8c4f9282.svg";